<div class="complete-profile-container">
  <!-- Background -->
  <div class="auth-background"></div>

  <!-- Main Card -->
  <div class="auth-card">

    <!-- Header -->
    <div class="auth-header">
      <div class="logo-section">
        <img src="/assets/befret_logo.png" alt="Befret" class="auth-logo">
        <h1 class="auth-title">{{ 'AUTH.COMPLETE_PROFILE.TITLE' | productionTranslate }}</h1>
      </div>
      <p class="auth-subtitle">{{ 'AUTH.COMPLETE_PROFILE.SUBTITLE' | productionTranslate }}</p>
    </div>

    <!-- Phone Display -->
    <div class="phone-display" *ngIf="displayPhone">
      <svg class="phone-icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
      <span>{{ displayPhone }}</span>
      <svg class="check-icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
      </svg>
    </div>

    <!-- Profile Form -->
    <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="profile-form">

      <!-- Full Name Field (Required) -->
      <div class="form-group">
        <label class="form-label">
          {{ 'AUTH.COMPLETE_PROFILE.FULL_NAME' | productionTranslate }}
          <span class="required">*</span>
        </label>
        <input
          type="text"
          formControlName="fullname"
          class="form-input"
          [class.error]="fullnameControl?.invalid && fullnameControl?.touched"
          [placeholder]="'AUTH.COMPLETE_PROFILE.FULL_NAME_PLACEHOLDER' | productionTranslate"
          autocomplete="name">

        <!-- Validation Error -->
        <div class="field-error" *ngIf="fullnameControl?.invalid && fullnameControl?.touched">
          <span *ngIf="fullnameControl?.errors?.['required']">
            {{ 'AUTH.COMPLETE_PROFILE.ERRORS.NAME_REQUIRED' | productionTranslate }}
          </span>
          <span *ngIf="fullnameControl?.errors?.['minlength']">
            {{ 'AUTH.COMPLETE_PROFILE.ERRORS.NAME_TOO_SHORT' | productionTranslate }}
          </span>
        </div>
      </div>

      <!-- Email Field (Required for account recovery) -->
      <div class="form-group">
        <label class="form-label">
          {{ 'AUTH.COMPLETE_PROFILE.EMAIL' | productionTranslate }}
          <span class="required">*</span>
        </label>
        <input
          type="email"
          formControlName="email"
          class="form-input"
          [class.error]="emailControl?.invalid && emailControl?.touched"
          [placeholder]="'AUTH.COMPLETE_PROFILE.EMAIL_PLACEHOLDER' | productionTranslate"
          autocomplete="email">

        <!-- Validation Error -->
        <div class="field-error" *ngIf="emailControl?.invalid && emailControl?.touched">
          <span *ngIf="emailControl?.errors?.['required']">
            {{ 'AUTH.COMPLETE_PROFILE.ERRORS.EMAIL_REQUIRED' | productionTranslate }}
          </span>
          <span *ngIf="emailControl?.errors?.['email'] && !emailControl?.errors?.['required']">
            {{ 'AUTH.COMPLETE_PROFILE.ERRORS.INVALID_EMAIL' | productionTranslate }}
          </span>
        </div>

        <!-- Email Recovery Warning -->
        <div class="recovery-warning">
          <svg class="warning-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
          </svg>
          <span>{{ 'AUTH.COMPLETE_PROFILE.EMAIL_RECOVERY_WARNING' | productionTranslate }}</span>
        </div>
      </div>

      <!-- Error Alert -->
      <div class="auth-error" *ngIf="errorMessage">
        <svg class="error-icon" viewBox="0 0 24 24">
          <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
        </svg>
        <span>{{ errorMessage | productionTranslate }}</span>
      </div>

      <!-- Submit Button -->
      <button
        type="submit"
        class="auth-submit-btn"
        [disabled]="profileForm.invalid || isLoading">
        <span class="btn-text" *ngIf="!isLoading">
          {{ 'AUTH.COMPLETE_PROFILE.SUBMIT' | productionTranslate }}
        </span>
        <div class="btn-loader" *ngIf="isLoading">
          <div class="spinner"></div>
          <span>{{ 'AUTH.COMPLETE_PROFILE.SAVING' | productionTranslate }}</span>
        </div>
      </button>

    </form>

    <!-- Info Text -->
    <div class="info-text">
      <svg class="info-icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
      </svg>
      <p>{{ 'AUTH.COMPLETE_PROFILE.INFO_TEXT' | productionTranslate }}</p>
    </div>

  </div>
</div>
